import { t } from "i18next";
import Header from "../../components/Assessment/Header/Header";
import "./Application.scss";
import {
  Bullets,
  DetailedListItem,
  Pagination,
  SkeletonList,
  TemplateSearch,
} from "ui-components";
import DataNotAvailable from "../../utils/DataNotFound/DataNotAvailable";
import { useEffect, useRef, useState } from "react";
import { setSessionStorageItem } from "../../utils/SessionStorageMethod/setSessionStorageItem";
import {
  capitalizeFirstLetter,
  convertDate,
  copyText,
  formatUrl,
  handleDownloadDocument,
} from "../../utils/Common/Constant";
import { useNavigate, useSearchParams } from "react-router-dom";
import GithubIcon from "../../utils/Images/GithubIcon";
import useDebounce from "../../utils/Hooks/useDebounce";
import EmailIcon from "../../utils/Images/EmailIcon";
import LinkedinIconSm from "../../utils/Images/LinkedinIconSm";
import { getCompanyApplications } from "../../service/StaffAugumentation/StaffAugumentationApis";
import DownloadCVIcon from "../../utils/Images/DownloadCVIcon";
import PhoneIcon from "../../utils/Images/PhoneIcon";
import Footer from "../../components/Footer/Footer";

const Application = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [totalCount, setTotalCount] = useState(20);
  const [pageSize, setPageSize] = useState(10);
  const [applicationLists, setApplicationLists] = useState<any>([]);
  const [managePaginationRef, setManagePaginationRef] = useState<any>(null);
  const paginaionRef = useRef<any>(null);
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const searchText = searchParams.get("search") || "";
  const debounceSearchText = useDebounce(searchText, 400);
  const currentPage = searchParams.get("page")
    ? Number(searchParams.get("page"))
    : 1;
  const handleFilter = ({ type, value }: any) => {
    let params: Record<string, any> = {
      page: currentPage,
      search: searchText,
    };

    switch (type) {
      case "page":
        params = { ...params, page: value };
        break;
      case "search":
        params = { ...params, search: value, page: 1 };
        break;
    }
    const queryString = new URLSearchParams(params).toString();
    navigate(`?${queryString}`);
  };
  useEffect(() => {
    if (paginaionRef.current && managePaginationRef != null) {
      paginaionRef.current.scrollIntoView({ behavior: "smooth" });
    }
  }, [managePaginationRef]);

  // API
  useEffect(() => {
    getPartnerInvitedList();
  }, [currentPage, pageSize, debounceSearchText]);

  const getPartnerInvitedList = async () => {
    setIsLoading(true);
    const getPartnerList: any = await getCompanyApplications(
      debounceSearchText,
      currentPage,
      pageSize,
    );
    if (getPartnerList?.status === 200) {
      setTotalCount(getPartnerList?.data?.totalCount);
      setApplicationLists(getPartnerList?.data?.data);
      setIsLoading(false);
    } else {
      setIsLoading(false);
    }
  };
  return (
    <>
      <Header />
      <div className="applicationList jobModuleStyle">
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-12">
              <h2 className="mb-4 staffTitle"> {t("RESUME.APPLICATIONS")}</h2>
              <div className="contractFilterSection">
                <div className="searchWithNew">
                  <TemplateSearch
                    onChange={(e) => {
                      handleFilter({ type: "search", value: e });
                    }}
                    iconName="searchList"
                    placeholder={t("APPLICATION.SEARCH_APPLICATIONS")}
                    value={searchText ?? ""}
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-md-12">
              <div className="minHeight60 applicationCards" ref={paginaionRef}>
                <p className="totalApplicants">
                  {t("APPLICATION.TOTAL_APPLICATIONS")} : {totalCount}
                </p>
                {isLoading ? (
                  <>
                    {Array.from({ length: 5 }).map((_, index) => (
                      <SkeletonList
                        key={`skeleton-${index}`}
                        numberOfTitles={1}
                        numberofTextLines={5}
                        titleSize={18}
                        textSize={12}
                        thumbnailHeight={250}
                        thumbnailWidth={250}
                        itemsGap={20}
                      />
                    ))}
                  </>
                ) : applicationLists?.length ? (
                  applicationLists.map((item: any, ind: number) => (
                    <div key={ind}>
                      <DetailedListItem
                        details={[
                          {
                            label: t("VENDOR.NAME"),
                            value: item?.vendorName ?? "_",
                          },
                          {
                            label: t("VENDOR.COMPANY_NAME"),
                            value: item?.vendorCompanyName ?? "_",
                            hoverValue: item.vendorCompanyName,
                          },
                          {
                            label: t("CONTRACT.VENDOR_EMAIL"),
                            value: item?.vendorEmail ?? "-",
                            hoverValue: item.vendorEmail,
                            onLabelClick: () => copyText(item.vendorEmail),
                            valueClassName: "cursorPointer",
                          },
                          {
                            label: t("GENERAL.TITLE"),
                            value: item?.jobName ?? "-",
                            hoverValue: item.jobName,
                          },
                          {
                            label: t("CONTRACT.TITLE"),
                            value: item?.contractTitle
                              ? item?.contractTitle
                              : "-",
                            hoverValue: item.contractTitle,
                          },
                          {
                            label: t("CONTRACT.CONTRACT_STATUS"),
                            value: item?.contractStatus
                              ? item?.contractStatus
                              : "-",
                          },
                          {
                            label: t("APPLICATION.CV_SCORE"),
                            value: `${item?.cvScore ? `${item.cvScore}%` : "-"}`,
                          },
                          {
                            label: t("APPLICATION.ASSESSMENT_SCORE"),
                            value: item?.assessmentScore?.score
                              ? item?.assessmentScore?.score + "%"
                              : "-",
                          },
                          {
                            label: t("GENERAL.ASSESSMENT.STATUS"),
                            value: item?.assessmentApplicantStatus
                              ? item?.assessmentApplicantStatus
                              : "-",
                          },
                        ]}
                        statusText={""}
                        statusType={
                          item?.appliedDate
                            ? convertDate(item?.appliedDate, false, true)
                            : "-"
                        }
                        title={item.resourceName ? item.resourceName : "-"}
                        titleBelow={
                          <div>
                            <div className="contactInfoSec">
                              {item?.email ? (
                                <div className="listTitleBelowSec">
                                  <div>
                                    <EmailIcon />
                                  </div>
                                  <span
                                    className="titleBelowContent cursorPointer"
                                    title={item?.email}
                                    onClick={() => copyText(item?.email)}
                                  >
                                    {item?.email ?? "-"}
                                  </span>
                                </div>
                              ) : (
                                ""
                              )}
                              {item?.mobile ? (
                                <div className="listTitleBelowSec">
                                  <div>
                                    <PhoneIcon />
                                  </div>
                                  <span className="titleBelowContent">
                                    {item?.mobile ?? "-"}
                                  </span>
                                </div>
                              ) : (
                                ""
                              )}
                            </div>

                            <div className="bulletSec">
                              {item?.skills?.map((sk: any) => {
                                return (
                                  <div key={ind}>
                                    <Bullets
                                      skillName={capitalizeFirstLetter(
                                        sk?.skillName,
                                      )}
                                    />
                                  </div>
                                );
                              })}
                            </div>
                          </div>
                        }
                        titleAlongside={
                          <div className="mediaDetails">
                            <div className="CvDownload ">
                              <span>{t("RESUME.CV")} : </span>
                              <span>
                                {item?.cvUrl
                                  ? item?.cvUrl && (
                                      <div
                                        title={t("RESUME.DOWNLOAD_CV")}
                                        className="downloadCVIcon"
                                        onClick={() =>
                                          handleDownloadDocument(item?.cvUrl)
                                        }
                                      >
                                        <DownloadCVIcon />
                                      </div>
                                    )
                                  : "-"}
                              </span>
                            </div>
                            {(item?.githubUrl || item?.linkedInUrl) && (
                              <div className="socialDetails">
                                <span>{t("RESUME.SOCIAL")} : </span>
                                {item?.linkedInUrl && (
                                  <div>
                                    <a
                                      href={formatUrl(item.linkedInUrl)}
                                      target="_blank"
                                      rel="noreferrer"
                                    >
                                      <LinkedinIconSm />
                                    </a>
                                  </div>
                                )}
                                {item?.githubUrl && (
                                  <div>
                                    <a
                                      href={formatUrl(item.githubUrl)}
                                      target="_blank"
                                      rel="noreferrer"
                                    >
                                      <GithubIcon />
                                    </a>
                                  </div>
                                )}
                              </div>
                            )}
                          </div>
                        }
                        statusIcon={<img src={item.profilePic} alt="" />}
                        columnCount={3}
                      />
                    </div>
                  ))
                ) : (
                  <div className="p-5">
                    <DataNotAvailable />
                  </div>
                )}
              </div>
              <div className="row">
                <div className="col-md-12">
                  <Pagination
                    className="pagination-bar"
                    currentPage={Number(currentPage)}
                    totalCount={totalCount || 0}
                    pageSize={pageSize}
                    onPageChange={(page: number) => {
                      handleFilter({ type: "page", value: page });
                      setSessionStorageItem("jobListPage", page);
                      setManagePaginationRef(Math.random());
                    }}
                    ofLabel={t("GENERAL.OF")}
                    resultLabel={t("GENERAL.RESULTS")}
                    setPageSize={setPageSize}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};
export default Application;
